import {
  ComponentBuilder,
  ComponentBuilderFetchDataInputs,
} from 'strapi/componentBuilder';

import TextWithTitle from './TextWithTitle';
import { TextWithTitleProps, TextWithTitleStrapiComponent } from './types';

export class TextWithTitleComponentBuilder extends ComponentBuilder {
  public key = 'text.text-with-title' as const;

  collectTextWithTitleComponentParams(data: TextWithTitleStrapiComponent) {
    return {
      showInRow: data.showInRow,
      sections: data.textSections,
    };
  }

  async fetchData(inputs: ComponentBuilderFetchDataInputs) {
    const fieldName = this.getFieldNameSymbol(inputs.componentData);

    const page = await inputs.fetchManager.addRequestOptionsAndWaitForResponse<{
      fieldName: TextWithTitleStrapiComponent;
    }>({
      populate: {
        [fieldName]: {
          populate: {
            textSections: true,
          },
        },
      },
    });

    const componentData = page[fieldName];
    if (!componentData) {
      return undefined;
    }

    const arrayComponentData = Array.isArray(componentData)
      ? componentData
      : [componentData];

    return arrayComponentData
      .map((componentData) =>
        this.collectTextWithTitleComponentParams(componentData)
      )
      .filter((x) => !!x) as TextWithTitleProps[];
  }

  render(inputs: Awaited<ReturnType<(typeof this)['fetchData']>>) {
    if (inputs && inputs.length > 0) {
      return (
        <>
          {inputs.map((input, index) => (
            <TextWithTitle key={`textWithTitle_${index}`} {...input} />
          ))}
        </>
      );
    } else {
      return null;
    }
  }
}
